import React, { useState } from "react";
import PropTypes from "prop-types";
import { Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";

const propTypes = {
  boostOptions: PropTypes.arrayOf(
    PropTypes.shape({
      impression_quantity: PropTypes.number,
      cost: PropTypes.number
    })
  ),
  onSelect: PropTypes.func.isRequired
};

const AddImpressions = ({ boostOptions = [], onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(boostOptions[0]);
  const [isEnabled, setIsEnabled] = useState(false);

  const toggle = () => setIsOpen(!isOpen);
  const toggleSwitch = () => {
    setIsEnabled(!isEnabled);
    if (!isEnabled) {
      onSelect(selectedOption);
    } else {
      onSelect(null);
    }
  };

  const handleSelect = option => {
    setSelectedOption(option);
    setIsOpen(false);
    if (isEnabled) onSelect(option);
  };

  const displayText = selectedOption
    ? `${selectedOption.impression_quantity} Views - $${Math.round(selectedOption.cost / 100)}`
    : `${boostOptions[0].impression_quantity} Views - $${Math.round(boostOptions[0].cost / 100)}`;

  return (
    <Row className="mt-4 mb-5">
      <div className="mt-3 mb-4 mx-3">
        Enable more views and give your sellers added exposure for their home in their targeted
        areas.
      </div>
      <Col>
        <Dropdown isOpen={isOpen} toggle={toggle} data-testid="boost-dropdown">
          <DropdownToggle caret className="btn btn-primary">
            {displayText}
          </DropdownToggle>
          <DropdownMenu>
            {boostOptions.map((option, index) => (
              <DropdownItem key={index} onClick={() => handleSelect(option)}>
                {`${option.impression_quantity} Views - $${Math.round(option.cost / 100)}`}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      </Col>
      <Col className="mb-4">
        <Row>
          <label className="toggle-switch mb-0" data-testid="toggle-switch">
            <input
              type="checkbox"
              id="impressions-toggle_active"
              data-testid="impressions-toggle_active"
              onChange={toggleSwitch}
              checked={isEnabled}
            />
            <span className="toggle round" />
          </label>
          <div className="toggle-label">
            <label
              htmlFor="impressions-toggle_active"
              className="mb-0"
              data-testid="add-more-views"
            >
              Add More Views
            </label>
          </div>
        </Row>
      </Col>
    </Row>
  );
};

AddImpressions.propTypes = propTypes;

export default AddImpressions;
